import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RandomCustomerEmoji from 'components/consumer/RandomCustomerEmoji';
import IconVerified from 'components/icons/iconVerified';
const CustomerNameWithEmoji = t0 => {
  const $ = _c(9);
  const {
    className: t1,
    children
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== children || $[1] !== className) {
    t2 = <RandomCustomerEmoji customerName={children} className={className} />;
    $[0] = children;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <h2 className="text-2xl font-bold inline mt-0 mr-0 mb-0 ml-5 relative md:top-[3px]">{children}{" "}</h2>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconVerified className="h-[18px] ml-1.5 relative top-[-3px] w-[18px] md:top-0 [&_path]:stroke-[#107c8c]" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <div className="text-2xl font-bold items-center text-gray flex mb-3">{t2}{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
CustomerNameWithEmoji.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default CustomerNameWithEmoji;